// violation.utils.js
import * as MuiIcons from "@mui/icons-material";

// Normalize status name for safe comparison
const normalize = (value = "") => value.trim().toLowerCase();

/**
 * Dynamically generates status config from backend-driven status meta.
 * @param {string} status - The status name from the violation object.
 * @param {Array} statuses - The full status metadata array from the API.
 * @returns {Object} { label, color, Icon }
 */
export const getViolationStatusDetails = (status = "", statuses = []) => {
  const normalized = normalize(status);
  const match = statuses.find((s) => normalize(s.statusname) === normalized);

  if (!match) {
    return {
      label: status || "Unknown",
      color: "default",
      Icon: MuiIcons.InfoOutlined,
    };
  }

  return {
    label: match.statusname,
    color: match.color || "default",
    Icon: MuiIcons[match.icon] || MuiIcons.InfoOutlined,
  };
};
